import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import PositiveListService from "src/modules/data-protection/apis/PositiveListService";
import { POSITIVE_LIST_ANALYSIS_QUERY_KEY } from "../helpers/analysisStatus";

const useReanalyzePositiveList = ({ softwareId, t } = {}) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            const service = PositiveListService.getInstance();

            return await service.reanalyze(softwareId);
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries([
                POSITIVE_LIST_ANALYSIS_QUERY_KEY,
                softwareId,
            ]);

            if (data?.status === "already_queued_or_processing") {
                toast(t("A Positive List analysis is already running."), {
                    type: "info",
                });
                return;
            }

            toast(t("Analysis has been queued."), {
                type: "success",
            });
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while starting the analysis."), {
                type: "error",
            });
        },
    });
};

export default useReanalyzePositiveList;
